import { Col, Form, Row } from "react-bootstrap"
import { Pass, Role } from "../data/models.interface"
import RolePassesSubForm from "./RolePassesSubForm"

interface IRoleForm {
	role: Role
	setRole: (role: Role) => void
	touched: Map<string, boolean>
	setTouched: (value: Map<string, boolean>) => void
	validationErrors: Map<string, string>
	setValidationErrors: (e: Map<string, string>) => void
	passes: Pass[]
}
const RoleForm = ({ role, setRole, touched, setTouched, validationErrors, setValidationErrors, passes }: IRoleForm) => {
	const setFieldTouched = (field: string) => {
		// need to make it a new object to trigger the state change
		touched = new Map(touched)
		touched.set(field, true)
		setTouched(touched)
	}
	const setName = (value: string) => {
		setRole({ ...role, name: value })
		//
		validationErrors = new Map(validationErrors)
		if (!value) validationErrors.set("name", "Name is required.")
		else validationErrors.delete("name")
		setValidationErrors(validationErrors)
	}
	return (
		<>
			<Row className="mt-4">
				<Col xs={12} sm={6} lg>
					<Form.Group className="mb-3" controlId="name">
						<Form.Label>Name</Form.Label>
						<Form.Control
							type="text"
							required
							value={role.name || ""}
							onChange={(e) => setName(e.target.value)}
							onBlur={() => setFieldTouched("name")}
							isInvalid={touched.get("name") && validationErrors.has("name")}
						/>
						<Form.Control.Feedback type="invalid">{validationErrors.get("name")}</Form.Control.Feedback>
					</Form.Group>
				</Col>
			</Row>
			<Row className="mt-4">
				<RolePassesSubForm
					rolePasses={role.passes}
					setRolePasses={(value) => setRole({ ...role, passes: [...value] })}
					passes={passes}
				/>
			</Row>
		</>
	)
}
export default RoleForm
